import { defineComponent as m, h as l, Fragment as f, computed as u } from "vue";
import h from "./highrise1112.mjs";
import p from "./highrise1053.mjs";
import o from "./highrise984.mjs";
import { useThemeClass as $ } from "./highrise1062.mjs";
import g from "./highrise1009.mjs";
const C = Object.assign(Object.assign({}, o.props), {
  titlePlacement: {
    type: String,
    default: "center"
  },
  dashed: Boolean,
  vertical: Boolean
}), y = m({
  name: "Divider",
  props: C,
  setup(t) {
    const {
      mergedClsPrefixRef: d,
      inlineThemeDisabled: r
    } = p(t), s = o("Divider", "-divider", h, g, t, d), n = u(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          color: a,
          textColor: v,
          fontWeight: c
        }
      } = s.value;
      return {
        "--n-bezier": e,
        "--n-color": a,
        "--n-text-color": v,
        "--n-font-weight": c
      };
    }), i = r ? $("divider", void 0, n, t) : void 0;
    return {
      mergedClsPrefix: d,
      cssVars: r ? void 0 : n,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t;
    const {
      $slots: d,
      titlePlacement: r,
      vertical: s,
      dashed: n,
      cssVars: i,
      mergedClsPrefix: e
    } = this;
    return (t = this.onRender) === null || t === void 0 || t.call(this), l("div", {
      role: "separator",
      class: [`${e}-divider`, this.themeClass, {
        [`${e}-divider--vertical`]: s,
        [`${e}-divider--no-title`]: !d.default,
        [`${e}-divider--dashed`]: n,
        [`${e}-divider--title-position-${r}`]: d.default && r
      }],
      style: i
    }, s ? null : l("div", {
      class: `${e}-divider__line ${e}-divider__line--left`
    }), !s && d.default ? l(f, null, l("div", {
      class: `${e}-divider__title`
    }, this.$slots), l("div", {
      class: `${e}-divider__line ${e}-divider__line--right`
    })) : null);
  }
});
export {
  y as default,
  C as dividerProps
};
